import DynamicPageRenderer from "../../components/DynamicPageRenderer";

const Maodo = () => {
  return <DynamicPageRenderer slug="histoire/maodo" />;
};

export default Maodo;
